import { isProd, isTest, isUat } from "./helpers/utils";

interface Config {
    oktagonUrl: string;
    apiUrl: string;
    wsUrl: string;
    cookieDomain: string;
    mixpanelToken?: string;
    mixpanelDebug?: boolean;
    maintenanceMode?: boolean;
}

const prodConfig: Config = {
    oktagonUrl: "https://auth.maxiluxcloud.com",
    apiUrl: "https://api.maxiluxcloud.com",
    wsUrl: "wss://api.maxiluxcloud.com",
    cookieDomain: ".maxiluxcloud.com",
    mixpanelToken: "af01356c4f01477bb95f3d4f06ea97e3",
    mixpanelDebug: false,
    maintenanceMode: true,
};

const testConfig: Config = {
    oktagonUrl: "https://test-auth.maxiluxcloud.com",
    apiUrl: "https://api.maxiluxcloud.com",
    wsUrl: "wss://api.maxiluxcloud.com",
    cookieDomain: ".maxiluxcloud.com",
    mixpanelToken: "f079c8fb300a43e24b2c1d40137a154a",
    mixpanelDebug: true,
    maintenanceMode: false,
};

const uatConfig: Config = {
    oktagonUrl: "https://auth.maxiluxsystems-uat.com",
    apiUrl: "https://api.maxiluxsystems-uat.com",
    wsUrl: "wss://api.maxiluxsystems-uat.com",
    cookieDomain: ".maxiluxsystems-uat.com",
    mixpanelToken: "f079c8fb300a43e24b2c1d40137a154a",
    mixpanelDebug: true,
    maintenanceMode: false,
};

const devConfig: Config = {
    oktagonUrl: "http://localhost:8001",
    apiUrl: "http://localhost:8006",
    wsUrl: "ws://localhost:8006",
    cookieDomain: ".localhost",
    mixpanelToken: "f079c8fb300a43e24b2c1d40137a154a",
    mixpanelDebug: true,
    maintenanceMode: false,
};

const getConfig = (): Config => {
    if (isProd) return prodConfig;
    if (isTest) return testConfig;
    if (isUat) return uatConfig;
    return devConfig;
};

const config: Config = getConfig();

export default config;
